import type { TFunction } from 'i18next';
import { HttpError } from '@/lib/http';

export function getDriverGroupNameError(error: Error | null, t: TFunction): string {
  if (error instanceof HttpError && error.status === 409) return t('driverGroups.errGroupExists');
  return error ? `${t('common.error')}: ${error.message}` : '';
}
